module.exports = __webpack_public_path__ + "img/infinity8ex_icon.1711a323.png";